import { memo } from 'react'
import { Icon } from '@winnin/ds-icon'

import type { IUploadPrimitiveViewProps } from './upload-primitive.types'
import './upload-primitive.styles.scss'

const Component = ({ children }: IUploadPrimitiveViewProps) => {
  return (
    <div className="UploadPrimitive">
      <Icon name="upload" width={20} height={20} className="UploadPrimitive-icon" />
      <div className="UploadPrimitive-content">{children}</div>
    </div>
  )
}

export const UploadPrimitiveView = memo(Component)
